import { createAction, handleActions } from 'redux-actions';

// ACTION CREATORS
export const getBackofficeInternalUsers = createAction('GET_BACKOFFICE_INTERNAL_USERS');
export const setBackofficeInternalUsers = createAction('SET_BACKOFFICE_INTERNAL_USERS');
export const createBackofficeInternalUser = createAction('CREATE_BACKOFFICE_INTERNAL_USER');
export const updateBackofficeInternalUser = createAction('UPDATE_BACKOFFICE_INTERNAL_USER');

// REDUCERS
export const reducer = handleActions(
  new Map([
    [
      setBackofficeInternalUsers,
      (state, action) => {
        return {
          ...state,
          users: action.payload
        }
      } 
    ]
  ]),
  { users: [] } 
);
